import SwiperSlider from "../base";

const selectors = {
  sliderEl: "[data-comp-thumbnail-slider]",
  nextEl: "[data-navigation-next-el]",
  prevEl: "[data-navigation-prev-el]",
};

const swiperOptions = {
  slidesPerView: 2,
  spaceBetween: 12,
  speed: 600,
  preventClicks: false,
  preventClicksPropagation: false,
  navigation: {
    nextEl: selectors.nextEl,
    prevEl: selectors.prevEl,
  },
  breakpoints: {
    500: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
    },
    992: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
    1400: {
      slidesPerView: 5,
    },
  },
};

export default class ThumbnailSlider extends SwiperSlider {
  static loaderPriority = "in-view";
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    this.thumbnailSlider = new this.Swiper(this.$container, swiperOptions);
    this.nextEl = this.$container.querySelector(selectors.nextEl);
    this.prevEl = this.$container.querySelector(selectors.prevEl);
    this.addListeners();
  }

  addListeners() {
    this.addSlideChangeListener();
    this.addOnUnloadListener();
  }

  addSlideChangeListener() {
    this.dispatchResizeEvent = dispatchResizeEvent.bind(this);
    this.thumbnailSlider.on("slideChange", this.dispatchResizeEvent);
  }

  addOnUnloadListener() {
    window.onunload = () => {
      this.removeSlideChangeListener();
    };
  }

  removeSlideChangeListener() {
    this.thumbnailSlider.off("slideChange", this.dispatchResizeEvent);
  }
}

function dispatchResizeEvent() {
  window.dispatchEvent(new Event("resize"));
}
